import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { fileSchema } from './file';
import { getPaginationResponseSchema } from './pagination';
import { ProcessorName } from './processor-name';
import { ServiceNameType } from './service';
export const documentPackageResultSchema = z
    .object({
    id: z.string().uuid(),
    document_package_id: z.string().uuid(),
    file: fileSchema,
    processor: z.nativeEnum(ProcessorName),
    type: z.nativeEnum(ServiceNameType),
    updated_at: z.string().datetime(),
    created_at: z.string().datetime(),
})
    .strict()
    .transform(mapToCamelCase);
export const getDocumentPackageResultsResponseSchema = getPaginationResponseSchema(documentPackageResultSchema);
export const documentPackageResultsResponseSchema = z
    .array(documentPackageResultSchema)
    .transform(mapToCamelCase);
export const createDocumentPackageResultRequestSchema = z
    .object({
    file_id: z.string().uuid(),
    processor: z.nativeEnum(ProcessorName),
    type: z.nativeEnum(ServiceNameType),
})
    .strict()
    .transform(mapToCamelCase);
export const getDocumentPackageResultsRequestSchema = z
    .object({
    project_id: z.number().int(),
    document_package_id: z.string().uuid(),
    page: z.union([z.number().int(), z.literal('all')]),
    page_size: z.number().int().nullish(),
    search: z.string().nullish(),
    processor: z.nativeEnum(ProcessorName).nullish(),
    type: z.nativeEnum(ServiceNameType).nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getDocumentPackageResultRequestSchema = z
    .object({
    project_id: z.number().int(),
    document_package_id: z.string().uuid(),
    result_id: z.string().uuid(),
})
    .strict()
    .transform(mapToCamelCase);
